
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3c468dd8&scoped=true!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./OfferComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./OfferComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-3c468dd8!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./OfferComponent.vue"),
  /* scopeId */
  "data-v-3c468dd8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/grid/OfferComponent.vue
// module id = 228
// module chunks = 2